import React from 'react';
import {Banner, Button, Dialogue} from '@albert-io/atomic';

interface Props {
  className?: string;
  handleClose?: () => void;
  inModal?: boolean;
  onCancel?: () => void;
  title?: React.ReactNode;
}

const GooglePopupBlockerWarning = ({onCancel, ...rest}: Props) => (
  <Dialogue title='Error' {...rest}>
    <Dialogue.Body>
      <Banner type='negative'>
        <Banner.Icon icon='exclamation-triangle' />
        <span>
          Your popup blocker is preventing you from proceeding. To continue, please disable your
          popup blocker for <strong>https://albert.io</strong>.
        </span>
      </Banner>
    </Dialogue.Body>
    <Dialogue.BtnGroup>
      <Button color='secondary' onClick={onCancel}>
        Back
      </Button>
    </Dialogue.BtnGroup>
  </Dialogue>
);

export default GooglePopupBlockerWarning;
